import { render, staticRenderFns } from "./CodeExchange.vue?vue&type=template&id=6efdad0a&scoped=true"
import script from "./CodeExchange.vue?vue&type=script&lang=js"
export * from "./CodeExchange.vue?vue&type=script&lang=js"
import style0 from "./CodeExchange.vue?vue&type=style&index=0&id=6efdad0a&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6efdad0a",
  null
  
)

export default component.exports